import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader } from 'lucide-react';
import { getPublicVideoDetails } from '../services/api';
import './EmbedPlayer.css';

const EmbedPlayer = () => {
  const { videoId } = useParams();
  const [video, setVideo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideoData = async () => {
      try {
        setLoading(true);
        console.log('🔍 Embed: Fetching video:', videoId);
        
        const data = await getPublicVideoDetails(videoId);
        console.log('✅ Embed: Got video:', data);
        
        setVideo(data);
      } catch (err) {
        console.error('❌ Embed: Error:', err);
        setError('Video not found or unavailable');
      } finally {
        setLoading(false);
      }
    };

    if (videoId) {
      fetchVideoData();
    }
  }, [videoId]);

  if (loading) {
    return (
      <div className="embed-loading">
        <Loader className="spinner" size={40} />
      </div>
    );
  }

  if (error || !video) {
    return (
      <div className="embed-error">
        <div className="error-icon">⚠️</div>
        <p>{error || 'Video not found'}</p>
      </div>
    );
  }

  return (
    <div className="embed-player">
      {/* Video Player */}
      <div className="embed-video-wrapper">
        <video
          controls
          autoPlay={false}
          className="embed-video"
          poster={video.thumbnail_url}
        >
          <source src={video.video_url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* AnimLearn Logo Watermark - CSS TEXT VERSION */}
        <div className="embed-watermark">
          <div className="watermark-logo-text">
            AnimLearn
          </div>
        </div>

        {/* Visit Site Overlay */}
        <div className="embed-overlay">
          <a 
            href={`https://animlearn.com/gallery?video=${videoId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="embed-cta"
          >
            <div className="cta-content">
              <div className="cta-icon">🎬</div>
              <div className="cta-text">
                <h3>Watch on AnimLearn</h3>
                <p>Create your own educational animations</p>
              </div>
            </div>
          </a>
        </div>
      </div>

      {/* Video Info Bar */}
      <div className="embed-info">
        <div className="embed-title">{video.scene_name}</div>
        <a 
          href="https://animlearn.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="embed-branding"
        >
          <div className="branding-logo-text">
            AnimLearn
          </div>
        </a>
      </div>
    </div>
  );
};

export default EmbedPlayer;
